import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ListCell } from '@axa-asia/emma-stylesheet/lib/components/ListTable';
import { getCustomerProfileConfig } from '../../../selectors/customerProfileSelectors';
import { editPolicyInfoLabels } from '../../../types/editPolicyInfo';
import { resolveLocalizedText } from '../../../../../utils';
import { goto } from '../../../../../actions/historyActions';
import './index.scss';
import {
  ContactInfoStatusType,
  UserTypes,
} from '../../../types/changeContactService';
import {
  UserTypeCodes,
  ContactInfoStatuses,
} from '../../../constants/constants';
export interface ChangeContactCardProps {
  editPolicyInfoLabels: editPolicyInfoLabels;
  planName: string;
  policyNumber: string;
  mobile: string;
  email: string;
  mobileStatus: ContactInfoStatusType;
  emailStatus: ContactInfoStatusType;
  mobileText: string;
  emailText: string;
  buttonNotCanClick: boolean;
  userType: UserTypes;
  certificateNumber: string;
  mobileDisplay: boolean;
  dependent: string;
  addressText: string;
  addressStatus: string;
}

export interface ChangeContactCardState {}

export class ChangeContactCard extends Component<
  ChangeContactCardProps,
  ChangeContactCardState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  gotoContactDetails = (policyNumber: string) => {
    goto(`emma-customer-profile/contact-details?policy_number=${policyNumber}`);
  };

  render() {
    const {
      editPolicyInfoLabels,
      planName,
      policyNumber,
      mobile,
      mobileDisplay,
      email,
      mobileStatus,
      emailStatus,
      mobileText,
      emailText,
      buttonNotCanClick,
      userType,
      certificateNumber,
      dependent,
      addressText,
      addressStatus,
    } = this.props;
    const {
      policyDependent,
      policyContactInformation,
      policyMobile,
      policyEmail,
      updateContact,
      correspondenceAddress,
    } = editPolicyInfoLabels;
    return (
      <div className="change-contant-card">
        <div>
          <b>{planName}</b>
        </div>
        <div className="change-contant-card-li">
          <span>PN: {policyNumber}</span>
          {userType === UserTypeCodes.EHK && (
            <span className="ml12">CN: {certificateNumber}</span>
          )}
        </div>
        {/* {
          userType === UserTypeCodes.EHK && dependent && <div className="change-contant-card-li">
            <div>{policyDependent ? resolveLocalizedText(policyDependent) : ''}</div>
            <div className="change-contant-card-li-value">{dependent}</div>
          </div>
        } */}
        <div className="change-contant-card-sub-title">
          <b>
            {policyContactInformation
              ? resolveLocalizedText(policyContactInformation)
              : ''}
          </b>
        </div>
        {mobileDisplay && (
          <ListCell
            valueClass={
              mobileStatus === ContactInfoStatuses.VALID
                ? 'change-contant-card-list-value'
                : 'change-contant-card-list-value-gray'
            }
            title={policyMobile ? resolveLocalizedText(policyMobile) : ''}
            value={mobileText}
          />
        )}
        <ListCell
          valueClass={
            emailStatus === ContactInfoStatuses.VALID
              ? 'change-contant-card-list-value'
              : 'change-contant-card-list-value-gray'
          }
          title={policyEmail ? resolveLocalizedText(policyEmail) : ''}
          value={emailText}
        />
        {
          <div>
            {userType === UserTypeCodes.LHK && (
              <div className="change-contant-card-address">
                <div className="change-contant-card-address-content content-align-right">
                  <div className="change-contant-card-address-content-left">
                    {correspondenceAddress
                      ? resolveLocalizedText(correspondenceAddress)
                      : ''}
                  </div>
                </div>
                <div
                  className={`change-contant-card-address-value ${
                    addressStatus === ContactInfoStatuses.VALID
                      ? 'change-contant-card-list-value'
                      : 'change-contant-card-list-value-gray'
                  }`}
                >
                  {addressText}
                </div>
              </div>
            )}
            <div className="change-contant-card-button">
              {buttonNotCanClick ? (
                <button className="emma-stylesheet-primary-secondary-default-disabled-button">
                  {updateContact ? resolveLocalizedText(updateContact) : ''}
                </button>
              ) : (
                <button
                  className="emma-stylesheet-primary-default-button"
                  data-enable-ga
                  data-ga-type="button"
                  onClick={() => this.gotoContactDetails(policyNumber)}
                >
                  {updateContact ? resolveLocalizedText(updateContact) : ''}
                </button>
              )}
            </div>
          </div>
        }
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const config = getCustomerProfileConfig(state) || {};
    return {
      editPolicyInfoLabels: config.editPolicyInfoLabels || {},
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  ChangeContactCard.mapStateToProps,
  ChangeContactCard.mapDispatchToProps,
)(ChangeContactCard);
